import styled from 'styled-components';

export const ScheduleModalContainer = styled.div`
  padding: 40px 80px;
  word-break: normal;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  @media (max-width: 768px) {
    padding: 20px 40px;
  }
`;

export const ModalWrapper = styled.div`
  @media (max-width: 768px) {
    & > div {
      height: 100%;
    }

    & > div > div:first-child {
      bottom: auto !important;
      min-width: 90dvw !important;
      width: 90dvw !important;
    }
  }
`;
